export default __webpack_public_path__ + "static/media/img-industry-advocacy.dc0216a0.svg";